// Minimal WebVTT parser for the player's own speaker-styled captions (§7.4). Pure.

export interface Cue {
  id: string;
  start: number;
  end: number;
  speaker: string | null;
  text: string;
}

const time = (t: string): number => {
  const p = t.trim().split(':').map(Number);
  return p.length === 3 ? p[0]! * 3600 + p[1]! * 60 + p[2]! : p[0]! * 60 + p[1]!;
};

const unescape = (s: string) => s.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&');

export function parseVtt(text: string): Cue[] {
  const blocks = text.replace(/\r/g, '').split(/\n\n+/);
  const cues: Cue[] = [];
  for (const b of blocks) {
    const lines = b.split('\n').filter(Boolean);
    const ti = lines.findIndex((l) => l.includes('-->'));
    if (ti < 0) continue;
    const [a, z] = lines[ti]!.split('-->') as [string, string];
    const body = lines.slice(ti + 1).join('\n');
    const v = /^<v ([^>]+)>([\s\S]*?)(<\/v>)?$/.exec(body);
    cues.push({
      id: ti > 0 ? lines[0]! : String(cues.length),
      start: time(a),
      end: time(z.split(' ')[1] ?? z),
      speaker: v ? v[1]! : null,
      text: unescape((v ? v[2]! : body).replace(/<[^>]+>/g, '')),
    });
  }
  return cues;
}

export const activeCues = (cues: Cue[], t: number): Cue[] => cues.filter((c) => t >= c.start && t < c.end);

/** Caption style class per speaker (the graphic novel's lettering). */
export function speakerClass(speaker: string | null): string {
  switch (speaker) {
    case 'ECHO':
      return 'cap-echo';
    case 'Mei':
      return 'cap-mei';
    case 'Kirov':
      return 'cap-kirov';
    case 'M.':
      return 'cap-m';
    case 'Guide':
      return 'cap-guide';
    case 'Bureau':
    case 'Bureau Courier':
      return 'cap-bureau';
    case 'Hilda':
      return 'cap-hilda';
    default:
      return 'cap-default';
  }
}
